import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import api from '../../api/axios';
import ChatBubble from '../Chat/ChatBubble';

const CatalogoPublico = () => {
  const { slug } = useParams();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchCatalog = async () => {
      try {
        const res = await api.get(`/catalogo/${slug}`);
             console.log("Respuesta catálogo:", res.data); // 👀 revisar estructura

        setData(res.data);
      } catch (error) {
        console.error('Error al cargar catálogo', error);
        setData({ error: true });
      } finally {
        setLoading(false);
      }
    };
    fetchCatalog();
  }, [slug]);

  if (loading) return <p className="text-center mt-5">Cargando catálogo...</p>;
  if (data?.error) return <p className="text-center mt-5 text-danger">No se pudo cargar el catálogo.</p>;

  return (
    <div className="container mt-4">
      <h2 className="mb-4 text-center">{data.business.name}</h2>
      {Object.keys(data.catalog).map((categoria) => (
        <div key={categoria} className="mb-4">
          <h4 className="text-primary border-bottom pb-1">{categoria}</h4>
          {data.catalog[categoria].map((producto) => (
            <div key={producto.id} className="mb-3">
              <h6 className="mb-1">{producto.name}:</h6>
              {producto.description && (
                <p className="mb-1 text-muted" style={{ fontSize: '0.9rem' }}>
                  {producto.description} ................................ <strong>${producto.price}</strong>
                </p>
              )}
{/*               <strong>${producto.price}</strong> */}
            </div>
          ))}
        </div>
      ))}
       {/* Chat flotante */}
{data?.business?.id && <ChatBubble businessId={data.business.id} />}


    </div>
  );
};

export default CatalogoPublico;
